<app-layout>
  <div class="home">
    <img src="assets/logotipo-home.svg" alt="Logo da Lavalog" />
  </div>
</app-layout>
